import { useEffect, useState } from 'react'
import { httpClientService } from '@services'
import type { Vessel, VesselSearchResponse } from '@app-types/index'

/**
 * Custom hook to fetch certificate status
 */
export const useCertificateStatus = (query: string, downloadPdf: boolean) => {
  const [data, setData] = useState<Vessel | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!query) {
      setData(null)
      setError(null)
      setLoading(false)
      return
    }

    const fetchCertificateStatus = async () => {
      try {
        setLoading(true)
        const response = await httpClientService.getCertificateStatus(query, downloadPdf)
        setData(response.data)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'))
      } finally {
        setLoading(false)
      }
    }

    void fetchCertificateStatus()
  }, [query, downloadPdf])

  return { data, loading, error }
}

/**
 * Custom hook to fetch vessel certificates
 */
export const useVesselCertificates = (searchWord: string) => {
  const [data, setData] = useState<VesselSearchResponse>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!searchWord) {
      setLoading(false)
      return
    }

    const fetchVesselCertificates = async () => {
      try {
        setLoading(true)
        const response = await httpClientService.getVesselCertificates(searchWord)
        setData(response.data)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'))
      } finally {
        setLoading(false)
      }
    }

    void fetchVesselCertificates()
  }, [searchWord])

  return { data, loading, error }
}
